<template>
  <div>
    <template v-for="(item,index) in artilcleList">
      <div class="article-list " @click="goToDetail(item)" :key="index">
          <div class="left">
            <img :src="setImgFn(item.sourceUrl)" alt width="100%" />
          </div>
          <div class="right px-1">
            <div class="title">{{item.postTitle}}</div>
            <div class="date">{{item.postDate}}</div>
            <div class="txt">{{item.postExcerpt}}</div>
          </div>
      </div>
    </template>
    
  </div>
</template>

<script>
export default {
  name: "ArticleList",
  props:['artilcleList'],
  data(){
    return{
    
    }
  },
  computed:{
    setImgFn(){
      return function(url){
        let index =  url.lastIndexOf('.');
        let tempUrl = url.slice(0,index)+'_related'+ url.slice(index);
        return tempUrl;
      }
    }
  },
  methods:{
    goToDetail(item){
      this.$router.push({
        path:'/detail',
        query:{
          postId:item.postId
        }
      })
    }
  },
  // watch: {
  //   '$route' (to, from) {
  //     this.$router.go(0);
  //   }
  // },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .article-list {
    margin-bottom: 10px;
    cursor: pointer;
    width: 100%;
    height: 3rem;
    float: left;
    font-size: 16px;
    padding: 0 0.5rem;
    .left {
      height: 3rem;
      width: 4rem;
      float: left;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right {
      height: 3rem;
      color: #101010;
      width: calc(100% - 4rem);
      float: left;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      line-clamp: 5;
      -webkit-box-orient: vertical;
      font-weight: 700;
      .date {
        // font-size: 0.12rem;
        display: none;
      }
      .txt {
        font-size: 16px;
        line-height: 0.4rem;
        // margin-top: 0.25rem;
        font-weight: 400;
        display: none;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .article-list {
    margin-bottom: 10px;
    height: 100% !important;
    .left {
      width: 3rem;
      float: left;
    }
    .right {
      float: left;
      width: calc(100% - 3rem);
    }
    cursor: pointer;
    width: 100%;
    height: 3rem;
    float: left;
    font-size: 0.28rem;
    .date {
      font-size: 0.12rem;
    }
    .txt {
      font-size: 0.16rem;
      // line-height: 0.4rem;
      // margin-top: 0.25rem;
      font-weight: 400;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.article-list:hover .title {
  color: #30a2e2;
}
</style>